import { Stack, Typography, useTheme } from "@mui/material";
import { CreatableSearchableSelect, Input } from "components";
import { useFormContext } from "react-hook-form";
import { CopySsoRedirectUrl } from "../copy-sso-redirect";

export const CreateSamlSso = ({
  customerDetailsData,
}: {
  customerDetailsData: any;
}) => {
  const theme = useTheme();
  const containerStyles = {
    padding: "16px 24px",
    border: `1px solid ${theme.palette.neutral["010"]}`,
    borderRadius: "8px",
    bgcolor: theme.palette.neutral.main,
  };

  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  const watchSsoConnectorId = watch("ssoConnectorId");

  return (
    <>
      <Stack
        sx={{
          gap: "24px",
          ...containerStyles,
        }}
      >
        <Stack>
          <Typography variant="h6">Domain details</Typography>
          {/* <Typography variant="body-small" color={theme.palette.lightBg.low}>
            Configure the metadata copied from the identity provider
          </Typography> */}
        </Stack>
        {/* <Input
          control={control}
          name="domain"
          label="Domain Name"
          placeholder="Enter domain name"
          errorMessage={errors?.domain?.message?.toString() || ""}
          error={errors?.domain ? true : false}
        /> */}
        <CreatableSearchableSelect
          name={"domain"}
          label="Domain Name"
          placeholder="Enter domain name"
          control={control}
          options={customerDetailsData?.domain_name || []}
          errorMessage={errors?.domain?.message?.toString() || ""}
          error={errors?.domain ? true : false}
          fullWidth
        ></CreatableSearchableSelect>
      </Stack>
      {watchSsoConnectorId && (
        <CopySsoRedirectUrl logtoConnectorId={watchSsoConnectorId} />
      )}
    </>
  );
};
